// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reviews_HRRoq{align-items:center;display:flex;line-height:1}@media only screen and (min-width:1264px){.reviews_HRRoq{outline-offset:-2px}}.reviews_HRRoq:hover .reviews__number_9uztf{-webkit-text-decoration:underline;text-decoration:underline}.reviews__number_9uztf{color:var(--cp-gray-12);font-size:1.2rem;line-height:1.8rem;margin-left:.3rem;position:relative;top:0}@media only screen and (min-width:1264px){.reviews__number_9uztf{font-size:1.3rem;line-height:2rem;top:.1rem}}.reviews_HRRoq.reviews_HRRoq .star-rating{grid-gap:.2rem;gap:.2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reviews": "reviews_HRRoq",
	"reviews__number": "reviews__number_9uztf"
};
module.exports = ___CSS_LOADER_EXPORT___;
